<template>
  <v-card class="text-xs-center">
    <storeApproveListTable />
  </v-card>
</template>

<script>
import storeApproveListTable from "@/components/back-office/Merchant/StoreApprove/StoreApproveListTable";
export default {
  data() {
    return {};
  },

  components: { storeApproveListTable },
  destroyed() {
    this.$store.commit("fetchStoreApproveBack/resetState");
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/",
      },
      {
        text: "Select service",
        disabled: false,
        href: "/weserve_admin_login/control/" + this.$route.params.province,
      },
      {
        text: "Store&Product",
        disabled: false,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/storemanage",
      },
      {
        text: "Contact Store Approve",
        disabled: true,
        href:
          "/weserve_admin_login/control/" +
          this.$route.params.province +
          "/storeandproduct/contactstoreapprove",
      },
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  },
};
</script>

<style>
</style>
